import { onRequest, RequestMethod } from "../common/axios/axios"
import { getApiUrl } from "../common/axios/getApiUrl"
import { getServiceId } from "../common/service"

export class NoticeRepository {
    static onGetNoticeList = (params: any) => {
        return onRequest({url: getApiUrl('notice-list'), method: RequestMethod.POST, params})
    }

    static onGetNoticeDetail = (noticeNo: number, serviceId?: string) => {
        const resolvedServiceId = serviceId || getServiceId()
        return onRequest({
            url: `${getApiUrl('notice-detail')}/${noticeNo}`,
            method: RequestMethod.GET,
            params: { serviceId: resolvedServiceId },
        })
    }
}
